<template>
  <div class="row">
    <div class="col-lg-3"></div>
    <div class="col-lg-6 col-12">
      <div class="card mt-3 bg-white">
        <div>
          <div
            class="card-body color-grey-primary"
            style="height: 460px; overflow: scroll; overflow-x: hidden"
          >
            <h3 class="color-primary">
              FAÇA UPLOAD DO SEU <strong>CURRÍCULO</strong>
            </h3>
            <div class="row">
              <div v-if="job.ask_remuneration" class="col-lg-12 col-12">
                <label class="f14">PODERIA INFORMAR SEU ÚLTIMO SALÁRIO??</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span id="basic-addon1" class="input-group-text">R$</span>
                  </div>
                  <currency-input
                    v-model="candidate.remuneration"
                    class="form-control"
                    placeholder="0,00"
                  />
                </div>
              </div>
              <div v-if="!job.hide_upload_cv" class="col-lg-12 col-12">
                <label>UPLOAD DO CURRÍCULO</label>
                <CurriculumUpload />
              </div>
              <div class="hide col-lg-12 col-12">
                <span class="help-block">
                  Visualize seu currículo abaixo:
                </span>
                <Resume
                  v-if="candidate_data.curriculum_text != ''"
                  :id="candidate_data.id"
                  :is_candidate="true"
                  :resume="candidate_data.curriculum_text"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="pl-3 mb-3 pr-3">
          <button
            :disabled="load"
            class="btn mt-2 full btn-success"
            type="button"
            @click="save"
          >
            <span v-show="!load">
              <span class="mr-3">SALVAR</span>
              <font-awesome-icon icon="chevron-right" />
            </span>
            <div v-show="load" class="spinner-border text-light" role="status">
              <span class="sr-only"></span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Resume from "@/Recruiters/TalentBank/Candidates/Resume.vue";
import CurriculumUpload from "components/CurriculumUpload.vue";

export default {
  components: { CurriculumUpload, Resume },
  props: ["job", "candidate_data"],
  data: () => ({
    load: false,
    resume: false,
    registerExperience: false,
    candidate: {
      remuneration: 0,
    },
  }),
  mounted() {
    if (
      this.candidate_data.curriculum_text &&
      this.candidate_data.curriculum_text != ""
    ) {
      this.resume = this.candidate_data.curriculum_text;
    }
    eventBus.$on("curriculum_load", (index) => {
      this.load = true;
    });

    eventBus.$on("curriculum_load", (value) => {
      if (!value) this.$toast.success("Upload do currículo feito com sucesso.");
      this.resume = true;
      this.load = value;
    });

    eventBus.$on("registerExperience", () => {
      this.registerExperience = true;
    });
  },
  methods: {
    save() {
      this.load = true;
      if (this.job.ask_remuneration) {
        if (this.candidate.remuneration == 0) {
          this.$toast.error("Digite a remuneração para continuar");
          this.load = false;
          return;
        }
      }

      if (!this.resume && this.job.mandatory_cv) {
        this.$toast.error("Faça o upload do currículo para continuar");
        this.load = false;
        return;
      }

      if (!this.resume && !this.registerExperience && this.job.mandatory_cv) {
        this.$toast.error(
          "Faça o upload do currículo, ou cadastre seu histórico profissional para continuar"
        );
        this.load = false;
        return;
      }

      // setTimeout(() => {
      axios
        .put("/candidates", {
          candidates: {
            remuneration: this.candidate.remuneration,
          },
        })
        .then((response) => {
          if (response.data.status == true) {
            this.$toast.success("Dados salvos com sucesso");
            eventBus.$emit("ExperiencieFinished");
            this.load = false;
          }
        });
      // }, 4000);
    },
  },
};
</script>
